// extracted by mini-css-extract-plugin
export var csatScore = "_mh-5";
export var header = "_mh-1";
export var panelWrapper = "_mh-2";
export var postPreview = "_mh-3";
export var rightContent = "_mh-0";
export var wrappingText = "_mh-4";